import { request } from "./request";
import { api_config } from "../constants/api";
const userUrl = api_config.API_V2_URL;
const googleUrl = api_config.googleUrl;


/**
 * 
 * @param {email:string,password:string} params 
 * @returns 
 */
export const login = (params) => {
    const options = {
        ...params,
        method: "POST",
    };
    return new Promise((resolve, reject) => {
        request(userUrl + "sessions", options).then((res) => {
            resolve(res)
        }).catch((err) => {
            console.log("errr", err)
            reject(err)
        })
    })
}

export const resetPassword = (params) => {
    const options = {
        ...params,
        method: "POST",
    };
    return new Promise((resolve, reject) => {
        request(userUrl + "accounts/password-reset", options).then((res) => {
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const checkEmail = (params) => {
    const options = {
        ...params,
        method: "POST",
    };
    return new Promise((resolve, reject) => {
        request(userUrl + "accounts/email-verify", options).then((res) => {
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}

/**
 * 
 * @param {email:string,
 *         password:string,
 *         code:number,
 *         token:string,
 *         confirm_password:string} params 
 * @returns 
 */
export const userRegister = (params) => {
    return new Promise((resolve, reject) => {
        const options = {
            ...params,
            method: "POST",
        };
        request(userUrl + "register", options).then((res) => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 
 * @param {email:string,
 *         is_validate?:0 || 1} params 
 * @returns 已经注册的用户忘记密码发送验证码时，需要加第二个字段，使其为1，否则报错
 */
export const sendVerification = (params) => {
    const options = {
        ...params,
        method: "POST",
    };
    return new Promise((resolve, reject) => {
        request(userUrl + "accounts/verification-code", options).then((res) => {
            resolve(res)
        }).catch(err => {
            reject(err);
        })
    })

}
/**
 * 
 * @param {current_password:string,
 *         new_password:string,
 *         new_password_confirmation} params 
 * @returns 
 */
export const changePassword = (params) => {
    return new Promise((resolve, reject) => {
        request(userUrl + "/accounts/password-change", {
            method: "POST",
            "Content-Type": "application/x-www-form-urlencoded",
            body: params
        }).then((res) => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    })
}
/////////登录


///////////登出
export const logOut = (params) => {
    return new Promise((resolve, reject) => {
        request(userUrl + "sessions", {
            method: "DELETE",
            "Content-Type": "application/x-www-form-urlencoded",
            body: params
        }).then((res) => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

///////////谷歌回调
export const googleCallback = (params) => {
    return new Promise((resolve, reject) => {
        request(userUrl + "google/callback", {
            method: "POST",
            "Content-Type": "application/x-www-form-urlencoded",
            body: params
        }).then((res) => {
            resolve(res)
        }).catch(err => {
            reject(err);
        })
    })
}

//////////谷歌授权邮箱验证
export const googleCheckEmail = (params) => {
    return new Promise((resolve, reject) => {
        request(googleUrl + "/api/v1/auth/google/oauth2", {
            method: "POST",
            "Content-Type": "application/x-www-form-urlencoded",
            body: params
        }).then((res) => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    })
}

export const addDefeatCount = () => {
    let res = localStorage.getItem("defeatCount");
    if (res === undefined) {
        localStorage.setItem("defeatCount", (1).toString());
    } else {
        localStorage.removeItem("defeatCount");
        let result = +res + 1;
        localStorage.setItem("defeatCount", (result).toString())

    }
}